import { NgModule, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
	TranslateModule,
} from "@codeandweb/ngx-translate";

import { UIRouterModule } from '@uirouter/angular';

import { ParametreService } from '@app/parametre/parametre.service';
import { GlobalModule } from '@app/_global/global.module';

@Component({
	templateUrl: 'auth.component.html'
})
export class AuthComponent implements OnInit {

	frontPage: string;
	mailtoHelp: string;

	constructor(private parametreService: ParametreService) {
		this.frontPage = this.parametreService.getParam('front_page');
		this.mailtoHelp = this.parametreService.getParam('mailto_help');
	}

	ngOnInit() { }

}

@NgModule({
	imports: [
		CommonModule,
		GlobalModule,
		UIRouterModule,
		TranslateModule,
	],
	exports: [AuthComponent],
	declarations: [AuthComponent]
})
export class AuthModule { }
